export default __webpack_public_path__ + "static/day1-93b0a65b0f6a4d958a88d5970fbb6188.jpg";